export default __webpack_public_path__ + "static/media/640_blank-es-mobile.2ddabcfc.png";